<template lang="pug">
  transform(:transform='transform',
            :parent-container='parentContainer',
            :render-tools='renderTools'
            :key='transform.id',
            :context='context',
            :disabled='!enableInteraction'
            :partutil='partutil')

    template(#holder="{depth,holder,outerContainer,innerContainer,displayObject,transform,parentTransform,allLoaded,context,...rest}")
      pbc-circle(v-if='isDrawAnchor(transform)',
             :center='{x:transform.transform.anchor.x,y:transform.transform.anchor.y}',
             :radius='20',
             :parent-container='innerContainer',
             :render-tools='renderTools'
             )

      edit-transform-interaction(
        :all-loaded='allLoaded'
        :holder='holder'
        :outer-container='outerContainer'
        :inner-container='innerContainer'
        :display-object='displayObject'
        :transform='transform'
        :parent-transform='parentTransform'
        :parent-container='parentContainer'
        :render-tools='renderTools'
        :partutil='partutil'
        :loading='loading'
        :selections='selections'
        :any-parent-selected='anyParentSelected'
        :indirect-selections='indirectSelections'
        :context='context'
        :enable-interaction='enableInteraction'
        :unselectable-transforms='unselectableTransforms'
        :rest='rest'
        @drag-start='onDragStart'
        @drag-end='onDragEnd'
        @select='onSelect'
        @deselect='onDeselect'
        @select-add='onSelectAdd'
      )
        template(#default='data')
          slot(name="default",v-bind="data")
        template(#selected='data')
          slot(name="selected",v-bind="data")
</template>
<script>
import Transform from '@edit/atoms/Transform.vue';
import EditTransformInteraction from './EditTransformInteraction.vue';
import { mapState } from 'vuex';
import PbcCircle from '@edit/atoms/Circle.vue';
export default {
  props: {
    transform: {
      type: Object,
      required: true
    },
    parentContainer: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    selections: {
      type: Object,
      default() {
        return {};
      }
    },
    anyParentSelected: {
      type: Boolean,
      default: false
    },
    indirectSelections:{
      type: Object,
      defauilt() {
        return {}
      }
    },
    context: {
      type: Object,
      default() {
        return {}
      }
    },
    enableInteraction: {
      type: Boolean,
      default: true
    },
    unselectableTransforms: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      isCached: false,
      enableCaching: true
    }
  },
  components: {
    PbcCircle,
    EditTransformInteraction,
    Transform,
  },
  computed: {
    originalTransform() {
      return this.transform;
    },
    outerTransform() {
      return this.transform;
    },
    ...mapState(['drawAnchorForTransformId'])
  },
  mounted() {
  },
  methods: {
    isDrawAnchor(transform) {
      return this.drawAnchorForTransformId === transform.id;
    },
    onDragStart(data) {
      this.$emit('drag-start', data);
    },
    onDragEnd(data) {
      this.$emit('drag-end', data);
    },
    onSelect(data) {
      this.$emit('select', data);
    },
    onDeselect(data) {
      this.$emit('deselect', data);
    },
    onSelectAdd(data) {
      this.$emit('select-add', data);
    }

  }
}
</script>
